// External dependencies

// Internal dependencies

export const BASE_PATH_REGEX = /^\/[a-z]{2}-[a-z]{2}/;
